import React from 'react';
import {
  FormControl,
  Typography,
  Tooltip,
  Box,
  Stack,
  TextField
} from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { useLanguage } from '../contexts/LanguageContext';

const ResponseLengthSelector = ({ responseLength, setResponseLength }) => {
  const { tr } = useLanguage();
  const [localLength, setLocalLength] = React.useState(() => {
    return localStorage.getItem('responseLength') || '100';
  });

  React.useEffect(() => {
    if (responseLength !== localLength) {
      setResponseLength(localLength);
    }
  }, []);

  const handleChange = (e) => {
    setLocalLength(e.target.value);
    setResponseLength(e.target.value);
  };

  return (
    <Box sx={{ bgcolor: '#fff', borderRadius: '4px', padding: '16px', boxShadow: '0 0 20px rgba(0,0,0,0.05)' }}>
      <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 1 }}>
        <Typography variant="subtitle2" sx={{ color: '#666' }}>
          {tr('回應 tokens 數', 'Response tokens')}
        </Typography>
        <Tooltip 
          title={
            <React.Fragment>
              <Typography variant="subtitle2" sx={{ fontWeight: 'bold', mb: 1 }}>{tr('回應 tokens 數說明', 'Response length guide')}</Typography>
              <Typography variant="body2" component="div">
                {tr(
                  <>設定 AI 回應的 tokens 數上限<br/>• 建議範圍：50-500 tokens<br/>• 可以依照需求調整長度</>,
                  <>Set the maximum length of the AI response.<br/>• Recommended: 50–500 tokens<br/>• Adjust it to suit the exercise</>
                )}
              </Typography>
            </React.Fragment>
          } 
          arrow 
          placement="right"
        >
          <HelpOutlineIcon sx={{ color: '#666', fontSize: 16, cursor: 'help' }} />
        </Tooltip>
      </Stack>
      <FormControl size="small" fullWidth>
        <TextField
          type="number"
          value={responseLength}
          onChange={handleChange}
          inputProps={{
            min: 50,
            max: 500,
            step: 10
          }}
          variant="outlined"
          size="small"
          sx={{
            bgcolor: '#f8f9fa',
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: 'transparent'
            },
            '&:hover .MuiOutlinedInput-notchedOutline': {
              borderColor: 'rgba(0, 0, 0, 0.1)'
            }
          }}
        />
      </FormControl>
    </Box>
  );
};

export default ResponseLengthSelector;
